import { defineStore } from "pinia";
import { ref } from "vue";

export const useInspectionLinksStore = defineStore("inspectionLinks", () => {
  let isDirty = ref(false);
  let pageReference = ref(null);
  let isSearching = ref(false);
  let isSaving = ref(false);
  let isPrinting = ref(false);
  let isAddingOrEditingJoints = ref(false);
  let isAddingOrEditingBearings = ref(false);
  let isAddingOrEditingLoadRatingDetails = ref(false);
  let isAddingOrEditingLoadRatingPostingDetails = ref(false);
  let isAddingOrEditingApproachSigns = ref(false);
  let isAddingOrEditingWaterway = ref(false);
  let isAddingOrEditingSchedule = ref(false);
  let showValidationSnackbar = ref(false);
  let isAddingOrEditingNotes = ref(false);
  let isAddingOrEditingNstmFatigue = ref(false);
  let showCalculate = ref(false);

  const resetAddingOrEditingTables = () => {
    isAddingOrEditingLoadRatingDetails.value = false;
    isAddingOrEditingLoadRatingPostingDetails.value = false;
    isAddingOrEditingApproachSigns.value = false;
    isAddingOrEditingJoints.value = false;
    isAddingOrEditingBearings.value = false;
    isAddingOrEditingWaterway.value = false;
    isAddingOrEditingNotes.value = false;
    isAddingOrEditingSchedule.value = false;
    isAddingOrEditingNstmFatigue.value = false;
  };

  const isAddingOrEditing = () => {
    return (
      isAddingOrEditingLoadRatingDetails.value ||
      isAddingOrEditingLoadRatingPostingDetails.value ||
      isAddingOrEditingApproachSigns.value ||
      isAddingOrEditingJoints.value ||
      isAddingOrEditingBearings.value ||
      isAddingOrEditingWaterway.value ||
      isAddingOrEditingNotes.value ||
      isAddingOrEditingSchedule.value ||
      isAddingOrEditingNstmFatigue.value
    );
  };

  return {
    showCalculate,
    isAddingOrEditingWaterway,
    isAddingOrEditing,
    resetAddingOrEditingTables,
    isAddingOrEditingNotes,
    showValidationSnackbar,
    isAddingOrEditingLoadRatingDetails,
    isAddingOrEditingLoadRatingPostingDetails,
    isAddingOrEditingApproachSigns,
    isAddingOrEditingBearings,
    isAddingOrEditingNstmFatigue,
    isDirty,
    isAddingOrEditingJoints,
    pageReference,
    isSearching,
    isSaving,
    isPrinting,
    isAddingOrEditingSchedule,
  };
});
